import axios from "../api/axios";
import { getDomainId } from "../lib/helpers";

const fetchValidateResetToken = async (token) => {
  try {
    const response = await axios.post("/recover/validate", { rt: token });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchVerifyEmail = async (data) => {
  try {
    const response = await axios.post("/confirm-email", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchContactUs = async (data) => {
  try {
    const domainId = await getDomainId();

    const response = await axios.post("/contact-us", { ...data, domainId });

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchAddEmailOrPhoneToWaitList = async (data, landingId) => {
  try {
    const domainId = await getDomainId();

    const { email, phoneNumber } = data;

    const payload = { domainId, email, phoneNumber };

    const linkClickId = localStorage.getItem("linkClickId");
    if (linkClickId) {
      payload.linkClickId = linkClickId;
    }

    if (landingId) {
      payload.landingPageId = landingId;
    }

    const response = await axios.post("/wait-list", JSON.stringify(payload));

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    if (linkClickId) {
      localStorage.removeItem("linkClickId");
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchAddOptIn = async (data) => {
  try {
    const { name, organization, phone, optInPage } = data || {};
    const domainId = await getDomainId();

    const payload = { domainId, name, organization, phone, optInPage };

    const response = await axios.post("/opt-ins", payload);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchPosts = async (params) => {
  try {
    const domainId = await getDomainId();

    const response = await axios.get(`/posts`, {
      params: { ...params, domainId },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchPostByLink = async (link) => {
  try {
    const domainId = await getDomainId();

    const response = await axios.get(`/posts/${link}`, {
      params: { domainId },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetMegaPages = async (params) => {
  try {
    const domainId = await getDomainId();

    const response = await axios.get(`/seo/mega-pages`, {
      params: { ...params, domainId },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetMegaPage = async (link) => {
  try {
    const domainId = await getDomainId();

    const response = await axios.get(`/seo/mega-pages/${link}`, {
      params: { domainId },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetMegaPageData = async (id) => {
  try {
    const response = await axios.get("/seo/data", {
      params: { megaPageId: id },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchFeaturedPost = async () => {
  try {
    const domainId = await getDomainId();

    const response = await axios.get("/posts/featured", {
      params: { domainId },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchRecommendColleague = async (data) => {
  try {
    const response = await axios.post(
      "/campaign-professionals/recommend-colleague",
      data
    );

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetCampaignProfessionals = async (params) => {
  const { filters, signal, ...rest } = params;
  const query = {
    ...rest,
    filters: filters ? JSON.stringify(filters) : undefined,
  };

  try {
    const response = await axios.get("/campaign-professionals", {
      params: query,
      signal,
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetCampaignProfessional = async (slugOrId) => {
  try {
    // Check if it's an ObjectId (24 characters, hexadecimal) or a slug
    const isObjectId = /^[0-9a-fA-F]{24}$/.test(slugOrId);
    const endpoint = isObjectId
      ? `/campaign-professionals/by-id/${slugOrId}`
      : `/campaign-professionals/by-slug/${slugOrId}`;

    const response = await axios.get(endpoint);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCreateCampaignProfessional = async (data) => {
  try {
    const response = await axios.post("/campaign-professionals", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetCampaignProfessionalRoles = async () => {
  try {
    const response = await axios.get("/campaign-professionals/roles");

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetCampaignProfessionalOfficeTypes = async () => {
  try {
    const response = await axios.get("/campaign-professionals/office-types");

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchSendCampaignProfessionalRequest = async (data) => {
  try {
    const response = await axios.post("/campaign-professionals/request", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCreateDeclaredCandidate = async (data) => {
  try {
    const response = await axios.post("/candidates", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchSubmitEbookLeadMagnet = async (data) => {
  try {
    const domainId = await getDomainId();
    const payload = { domainId, ...data };

    const response = await axios.post(
      "/ebook-lead-magnet",
      JSON.stringify(payload)
    );

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCreateClientOnboarding = async (data) => {
  try {
    const response = await axios.post("/client-onboarding", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCreateCampaignOnboarding = async (data) => {
  try {
    const response = await axios.post("/campaign-onboarding", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchGetPublicDonationPage = async (campaignTag) => {
  try {
    const response = await axios.get("/donationPages/public", {
      params: { tag: campaignTag },
    });

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCreateDonationPaymentIntent = async (data) => {
  try {
    const response = await axios.post("/donationPayments/createIntent", data);

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCreateDonationSubscription = async (data) => {
  try {
    const response = await axios.post(
      "/donationPayments/createSubscription",
      data
    );

    if (response.status !== 200) {
      return { success: false, message: response.message };
    }

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

const fetchCampaignReport = async ({ companySlug, campaignSlug, auth }) => {
  try {
    const response = await axios.get("/campaign-report", {
      params: { company: companySlug, campaign: campaignSlug, auth },
    });

    return response.data;
  } catch (error) {
    return {
      success: false,
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
    };
  }
};

export {
  fetchCampaignReport,
  fetchValidateResetToken,
  fetchVerifyEmail,
  fetchContactUs,
  fetchAddEmailOrPhoneToWaitList,
  fetchAddOptIn,
  fetchPosts,
  fetchPostByLink,
  fetchGetMegaPages,
  fetchGetMegaPage,
  fetchGetMegaPageData,
  fetchFeaturedPost,
  fetchRecommendColleague,
  fetchGetCampaignProfessionals,
  fetchGetCampaignProfessional,
  fetchCreateCampaignProfessional,
  fetchGetCampaignProfessionalRoles,
  fetchGetCampaignProfessionalOfficeTypes,
  fetchSendCampaignProfessionalRequest,
  fetchCreateDeclaredCandidate,
  fetchSubmitEbookLeadMagnet,
  fetchCreateClientOnboarding,
  fetchCreateCampaignOnboarding,
  fetchGetPublicDonationPage,
  fetchCreateDonationPaymentIntent,
  fetchCreateDonationSubscription,
};
